import { type EnrichLeadCaptureContact } from "api/enrich";

export const EnrichStatus = {
  NOT_STARTED: "NOT_STARTED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
} as const;
export type EnrichStatusType = (typeof EnrichStatus)[keyof typeof EnrichStatus];

type EnrichStatus =
  | NonNullable<EnrichLeadCaptureContact["enrich_status"]>
  | "ALREADY_ENRICHED"
  | "INFO_NOT_FOUND";

export const enrichMessages: Record<EnrichStatus, string> = {
  COMPLETED: "Enrichment completed.",
  ALREADY_ENRICHED:
    "This contact is already enriched and new information has been added.",
  FAILED: "No additional data is available for this contact. ",
  INFO_NOT_FOUND: "No additional data is available for this contact. ",
  IN_PROGRESS:
    "We're gathering data from multiple sources. Hang tight, this may take up to a minute.",
  NOT_STARTED: "",
};

export const enrichErrorMessages = {
  FAILED: "Failed to enrich contact",
};
